'use client';

import { useRef, useState, useEffect } from 'react';
import { useInView } from 'framer-motion';
import CountUp, { CountUpProps } from 'react-countup';

export default function CountUpOnlyOnce(props: CountUpProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [start, setStart] = useState(false);

  useEffect(() => {
    if (isInView) setStart(true);
  }, [isInView]);

  return (
    <div ref={ref}>
      {/* {start && <CountUp end={end} duration={duration} />} */}
       {start && <CountUp {...props} />}
    </div>
  );
}
